import React from 'react';
import { useTranslation } from 'react-i18next';
import { triggerHaptic } from '../../utils/haptics';

export const LanguageSelector: React.FC = () => {
    const { i18n } = useTranslation();

    const languages = [
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'es', name: 'Español', flag: '🇪🇸' }
    ];

    const changeLanguage = (lng: string) => {
        triggerHaptic('light');
        i18n.changeLanguage(lng);
    };

    const currentLanguage = i18n.language.split('-')[0]; // Handle cases like 'en-US'

    return (
        <div className="flex items-center gap-1 bg-surface-2/50 backdrop-blur-sm p-1 rounded-xl border border-white/10 shadow-sm">
            {languages.map((lang) => (
                <button
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    title={lang.name}
                    className={`w-9 h-9 flex items-center justify-center rounded-lg transition-all duration-200 ${currentLanguage === lang.code
                            ? 'bg-primary text-white shadow-md scale-105'
                            : 'text-text-secondary hover:bg-surface-3 hover:text-text-primary'
                        }`}
                >
                    <span className="text-xl scale-110 grayscale-[0.2] hover:grayscale-0">{lang.flag}</span>
                </button>
            ))}
        </div>
    );
};
